'use client';

import ArticleCard from '@/components/ArticleCard';
import { CardResource } from '@/services/cms/types';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './resourceHero.module.scss';

type ResourceHeroProps = {
  readonly header: string;
  readonly featuredArticle: CardResource;
  readonly smallArticles: CardResource[];
};

export default function ResourceHero({
  header,
  featuredArticle,
  smallArticles
}: ResourceHeroProps) {
  return (
    <section
      className={`${styles.resourceHero} ${commonStyles.sectionContent}`}
    >
      <h1 className={commonStyles.sectionHeading}>{header}</h1>

      <div className={styles.content}>
        <div className={styles.featured}>
          <ArticleCard
            article={featuredArticle}
            variant="vertical"
            metaDisplay="type"
            hideDescription
            showArrowButton
            background={'dark'}
          />
        </div>

        <div className={styles.smallCards}>
          {smallArticles.slice(0, 3).map((article) => (
            <ArticleCard
              key={'documentId' in article ? article.documentId : article.id}
              article={article}
              metaDisplay="type"
              variant="horizontalSmall"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
